/**
 * AppTopbar - top bar for client app
 */
import { Bell, Search, Plus, Menu } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LOGO_URL } from "@/lib/brand";
import AppSidebar from "./AppSidebar";
import { Badge } from "@/components/ui/badge";

export default function AppTopbar() {
    const { user } = useAuth();
    const planLabel =
        user?.plan_id === "pro"
            ? "Pro"
            : user?.plan_id === "empresarial"
            ? "Empresarial"
            : user?.plan_id === "basico"
            ? "Básico"
            : user?.subscription_status === "trial"
            ? "Trial"
            : "Sem plano";

    return (
        <header
            className="sticky top-0 z-30 backdrop-blur-md bg-background/80 border-b border-border h-16 flex items-center px-4 sm:px-6 gap-3"
            data-testid="app-topbar"
        >
            {/* mobile drawer trigger */}
            <Sheet>
                <SheetTrigger asChild className="lg:hidden">
                    <Button variant="ghost" size="icon" data-testid="app-mobile-menu-button">
                        <Menu className="h-5 w-5" />
                    </Button>
                </SheetTrigger>
                <SheetContent side="left" className="p-0 w-[280px] dark bg-background">
                    <div className="dark min-h-full bg-background">
                        <AppSidebar />
                    </div>
                </SheetContent>
            </Sheet>

            {/* mobile logo */}
            <Link to="/painel" className="lg:hidden flex items-center gap-2" data-testid="app-mobile-logo">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-[#0B0B10] overflow-hidden">
                    <img src={LOGO_URL} alt="MeSafa" className="h-8 w-8 object-contain" />
                </span>
                <span className="font-display font-bold text-base">
                    <span className="text-[#A78BFA]">me</span>Safa
                </span>
            </Link>

            {/* search (desktop) */}
            <div className="hidden md:flex items-center flex-1 max-w-md ml-2">
                <div className="relative w-full">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                        placeholder="Pesquisar publicações, canais…"
                        className="pl-9 bg-secondary/40"
                        data-testid="app-search-input"
                    />
                </div>
            </div>

            <div className="flex-1 md:flex-none" />

            {/* plan badge */}
            <Badge
                variant="outline"
                className="hidden sm:inline-flex border-[#6B21D9]/40 bg-[#6B21D9]/10 text-[#A78BFA]"
                data-testid="app-plan-badge"
            >
                Plano {planLabel}
            </Badge>

            {/* New post quick action */}
            <Button asChild className="hidden sm:inline-flex" data-testid="app-quick-new-post">
                <Link to="/publicacoes?new=1" className="gap-2">
                    <Plus className="h-4 w-4" /> Nova publicação
                </Link>
            </Button>

            <Button variant="ghost" size="icon" data-testid="app-notifications-button">
                <Bell className="h-4 w-4" />
            </Button>
        </header>
    );
}
